export default {
  // serverUrl: "https://d28ag1ebuf0g4e.cloudfront.net/", // prd
  // serverUrl: "https://d2hexn26qz16n5.cloudfront.net/", // dev
  // serverUrl: "http://localhost:8081/",
  serverUrl: process.env.VUE_APP_SERVER_URL,
  // serverUrl: "https://depa.techunt-dev.witsawa.com/",
  // liffid: "1660869230-WXYZb2dP", //dev
  liffid: process.env.VUE_APP_LIFF_ID
};
